import { render } from "./Mentions.vue?vue&type=template&id=7151738c&ts=true"
import script from "./Mentions.vue?vue&type=script&lang=ts"
export * from "./Mentions.vue?vue&type=script&lang=ts"

import "./Mentions.vue?vue&type=style&index=0&id=7151738c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Mentions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7151738c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7151738c', __exports__)) {
    api.reload('7151738c', __exports__)
  }
  
  module.hot.accept("./Mentions.vue?vue&type=template&id=7151738c&ts=true", () => {
    api.rerender('7151738c', render)
  })

}


export default __exports__